export class Rectangle {
    x : number;
    y: number;
    width: number;
    height: number;
    bottom: number;
    bottomRight: number;
    top: number;
    topLeft: number;
    left: number;
    right: number;
    size: number;
}